import React from 'react'
import { useTranslation } from 'react-i18next';
import CountProjects from '../../shared/CountProjects';
import ProjectAvatar from '../../shared/ProjectAvatar';

const ProjectsWithMICI = ({ mp, isLoan, isTcp, isIgr, titleLon, titleTcp, titleIgr }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="panel-body-safeguards">
                <div style={{ margin: '2rem' }}>
                    <CountProjects total={mp.ProjectsMICI.totalProjectCount} info={`${t('extended_report.with_MICI')}`} />

                    <div className="c-content project-avatar" style={{ marginTop: '1rem' }}>
                        {(isLoan) && (<ProjectAvatar label={titleLon} value={mp.ProjectsMICI.totalProjectCountLon} className="avatar-style-lon" />)}
                        {(isTcp) && (<ProjectAvatar label={titleTcp} value={mp.ProjectsMICI.totalProjectCountTcp} className="avatar-style-tcp" />)}
                        {(isIgr) && (<ProjectAvatar label={titleIgr} value={mp.ProjectsMICI.totalProjectCountIgr} className="avatar-style-igr" />)}
                    </div>

                    <div className='last-text'>
                        <p>{t('extended_report.references_come_from_MICI_website')}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProjectsWithMICI